export const API_DOMAIN = "https://tiq8.moramba.io/api/cibona/v1/";

export class GlobalConstants {
    static appXml =
      '<resources><string name="app_name">Tiq8</string></resources>';
    static localLanguage = "en";
    static session_lang_xml = "lang_xml";
    static session_default_language = "default_language";
  }